<h1>Prep Locations</h1>
<div class="button-container">
  @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
    <button
      mat-flat-button
      class="modal-link-button remove-hours-override-link"
      (click)="openRemoveScheduledHoursOverridesDialog()">
      Remove Scheduled Hours Overrides
    </button>
  }
</div>
<div class="prep-locations-container">
  <div class="header-container">
    <div class="column col-1">Prep Location Type</div>
    <div class="column col-2">Today's Hours</div>
    <div class="column col-3">Capacity (per 15 min.)</div>
    <div class="column col-4">Default Prep Time</div>
  </div>
  <mat-accordion>
    @for (prepLocation of prepLocationForComponents; track prepLocation) {
      <mat-expansion-panel (opened)="setHoursChanged(prepLocation.prepLocationTypeName)">
        <mat-expansion-panel-header>
          <div class="expansion-header-container">
            <mat-panel-title class="column col-1">
              {{ prepLocation.prepLocationTypeName }}
            </mat-panel-title>
            <mat-panel-description class="column col-2">
              {{ prepLocation.openTimeToday | timeOnly }} - {{ prepLocation.closeTimeToday | timeOnly }}
            </mat-panel-description>
            <mat-panel-description class="column col-3">
              {{ prepLocation.maxSlotItemCount }} items
            </mat-panel-description>
            <mat-panel-description class="column col-4">
              {{ prepLocation.defaultPrepMinutes }} minutes
            </mat-panel-description>
          </div>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <section>
            <h2>Business Hours</h2>
            @if (authManager.doesCurrentAccountHaveAnyRole(["Division", "IT", "Admin"])) {
              <button
                mat-flat-button
                class="modal-link-button"
                color="secondary"
                (click)="scheduleHoursException(prepLocation)">
                Schedule Hours Override
              </button>
            }
            <button
              mat-flat-button
              class="modal-link-button"
              color="secondary"
              (click)="viewScheduledHoursExceptions(prepLocation)">
              View Scheduled Hours Overrides
            </button>
            @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
              <div>
                <mat-grid-list cols="2" rowHeight="100px">
                  @for (day of sections.hours.changedState; track day) {
                    <mat-grid-tile>
                      <div class="prep-locations-header-text">{{ day.dayOfWeek | day }}</div>
                      <mat-form-field appearance="fill">
                        <mat-label>Open</mat-label>
                        <mat-select [(value)]="day.openIndex">
                          @for (time of timeRange; track time) {
                            <mat-option
                              [value]="time.index"
                              (click)="openTimeSelected(time.time, day.dayOfWeek, prepLocation.prepLocationTypeName)">
                              {{ time.time | timeOnly }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Close</mat-label>
                        <mat-select [(value)]="day.closeIndex">
                          @for (time of timeRange; track time) {
                            <mat-option
                              [value]="time.index"
                              (click)="closeTimeSelected(time.time, day.dayOfWeek, prepLocation.prepLocationTypeName)">
                              {{ time.time | timeOnly }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </mat-grid-tile>
                  }
                </mat-grid-list>
              </div>
            }
            @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
              <div class="buttons">
                @if (!hoursChanged(prepLocation)) {
                  <button
                    mat-flat-button
                    class="modal-link-button"
                    color="secondary"
                    (click)="applyHoursToMultiplePrepLocations(prepLocation)">
                    Apply to Multiple Prep Locations
                    @if (sections.hours.prepLocationsSelected > 1) {
                      <span>({{ sections.hours.prepLocationsSelected }})</span>
                    }
                  </button>
                }
                @if (!hoursChanged(prepLocation)) {
                  <button
                    mat-flat-button
                    class="modal-link-button"
                    color="secondary"
                    (click)="applyHoursToMultipleStores(prepLocation)">
                    Apply to Multiple Stores
                    @if (sections.hours.storesSelected > 1) {
                      <span>({{ sections.hours.storesSelected }})</span>
                    }
                  </button>
                }
                <button mat-flat-button class="cancel-button" color="secondary" (click)="cancelHours(prepLocation)">
                  Cancel
                </button>
                <button
                  mat-raised-button
                  class="save-button"
                  color="accent"
                  [disabled]="hoursChanged(prepLocation)"
                  (click)="saveHours(prepLocation)">
                  Save
                </button>
              </div>
            }
          </section>
          @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
            <section>
              <h2>Capacity</h2>
              <div class="counter">
                <increment-input
                  [(value)]="sections.capacity.changedState"
                  [step]="1"
                  [min]="0"
                  [max]="1000"
                  unit="items per 15 minutes">
                </increment-input>
              </div>
              <div class="buttons">
                @if (prepLocation.maxSlotItemCount !== sections.capacity.changedState) {
                  <button
                    mat-flat-button
                    class="modal-link-button"
                    color="secondary"
                    (click)="applyCapacityToMultipleStores(prepLocation)">
                    Apply to Multiple Stores
                    @if (sections.capacity.storesSelected > 1) {
                      <span>({{ sections.capacity.storesSelected }})</span>
                    }
                  </button>
                }
                <button mat-flat-button class="cancel-button" color="secondary" (click)="cancelCapacity(prepLocation)">
                  Cancel
                </button>
                <button
                  mat-raised-button
                  class="save-button"
                  color="accent"
                  [disabled]="prepLocation.maxSlotItemCount === sections.capacity.changedState"
                  (click)="saveCapacity(prepLocation)">
                  Save
                </button>
              </div>
            </section>
          }
          @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
            <section>
              <h2>Default Prep Time</h2>
              <div class="counter">
                <increment-input
                  [(value)]="sections.defaultPrepMinutes.changedState"
                  [step]="1"
                  [min]="0"
                  [max]="14400"
                  unit="minutes">
                </increment-input>
              </div>
              <div class="buttons">
                @if (prepLocation.defaultPrepMinutes !== sections.defaultPrepMinutes.changedState) {
                  <button
                    mat-flat-button
                    class="modal-link-button"
                    color="secondary"
                    (click)="applyDefaultPrepToMultipleStores(prepLocation)">
                    Apply to Multiple Stores
                    @if (sections.defaultPrepMinutes.storesSelected > 1) {
                      <span>({{ sections.defaultPrepMinutes.storesSelected }})</span>
                    }
                  </button>
                }
                <button
                  mat-flat-button
                  class="cancel-button"
                  color="secondary"
                  (click)="cancelDefaultPrep(prepLocation)">
                  Cancel
                </button>
                <button
                  mat-raised-button
                  class="save-button"
                  color="accent"
                  [disabled]="prepLocation.defaultPrepMinutes === sections.defaultPrepMinutes.changedState"
                  (click)="saveDefaultPrepMinutes(prepLocation)">
                  Save
                </button>
              </div>
            </section>
          }
          @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
            <section>
              <h2>Early Prep Warning</h2>
              <div>
                <label class="availability-switch">
                  <mat-slide-toggle [(ngModel)]="sections.earlyPrepWarning.changedState"></mat-slide-toggle>
                </label>
                <span>{{ earlyPrepWarningText(sections.earlyPrepWarning.changedState) }}</span>
              </div>
              <div class="buttons">
                @if (prepLocation.alertOnEarlyStartPrep !== sections.earlyPrepWarning.changedState) {
                  <button
                    mat-flat-button
                    class="modal-link-button"
                    color="secondary"
                    (click)="applyEarlyPrepWarningToMultipleStores(prepLocation)">
                    Apply to Multiple Stores
                    @if (sections.earlyPrepWarning.storesSelected > 1) {
                      <span>({{ sections.earlyPrepWarning.storesSelected }})</span>
                    }
                  </button>
                }
                <button
                  mat-flat-button
                  class="cancel-button"
                  color="secondary"
                  (click)="cancelEarlyPrepWarning(prepLocation)">
                  Cancel
                </button>
                <button
                  mat-raised-button
                  class="save-button"
                  color="accent"
                  [disabled]="prepLocation.alertOnEarlyStartPrep === sections.earlyPrepWarning.changedState"
                  (click)="saveEarlyPrepWarning(prepLocation)">
                  Save
                </button>
              </div>
            </section>
          }
          @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin", "Division"])) {
            <section>
              <h2>All Day View</h2>
              <p>Show a running total of in-progress items on the prep Open Orders page.</p>
              <div>
                <label class="availability-switch">
                  <mat-slide-toggle [(ngModel)]="sections.allDayView.changedState"></mat-slide-toggle>
                </label>
                <span>{{ allDayViewText(sections.allDayView.changedState) }}</span>
              </div>
              <div class="buttons">
                @if (prepLocation.showAllDayView !== sections.allDayView.changedState) {
                  <button
                    mat-flat-button
                    class="modal-link-button"
                    color="secondary"
                    (click)="applyAllDayViewToMultipleStores(prepLocation)">
                    Apply to Multiple Stores
                    @if (sections.allDayView.storesSelected > 1) {
                      <span>({{ sections.allDayView.storesSelected }})</span>
                    }
                  </button>
                }
                <button
                  mat-flat-button
                  class="cancel-button"
                  color="secondary"
                  (click)="cancelAllDayView(prepLocation)">
                  Cancel
                </button>
                <button
                  mat-raised-button
                  class="save-button"
                  color="accent"
                  [disabled]="prepLocation.showAllDayView === sections.allDayView.changedState"
                  (click)="saveAllDayView(prepLocation)">
                  Save
                </button>
              </div>
            </section>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
</div>
